import React, { useEffect, useState } from "react";
import { FiEdit } from "react-icons/fi";
import styled from "styled-components";

const Wrapper = styled.div`
  flex: 1 1 calc(50% - 20px);
  display: flex;

  @media (max-width: 768px) {
    flex: 1 1 100%;  /* карточка занимает весь ряд */
  }
`;

const Box = styled.div`
  background: #0f0f0f;
  border-radius: 14px;
  padding: 20px;
  flex: 1;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid #1c1c1c;
    @media (max-width: 768px) {
    min-height: 80px;
    
  }
`;

const Title = styled.div`
  color: #ffffff;
  font-size: 18px;
`;

const BarWrapper = styled.div`

    height: 32px;
  border: 1px solid #1c1c1c;
  padding: 6px 12px 6px 12px;

  border: 1px solid #1F1F1F;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  background: #0E0E10;
  
`;

const ProgressBarFill = styled.div<{ percent: number }>`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  /* ширина с учётом внутреннего padding */
  width: ${(p) => `calc(${p.percent}% - 24px)`};
  max-width: 100%;
  background: #0088FF;
  transition: width 0.3s ease;
`;
const ProgressText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 13px;
  line-height: 20px;
  font-weight: 500;
  pointer-events: none;
`;

const Status = styled.div<{ statusColor?: string }>`
  border-radius: 20px;
  padding: 6px 12px 6px 12px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
    color: white;
 
border: 1px solid #FF8D28;

`;

const ExpandButton = styled.button`
  padding: 6px 12px;
  height: 32px;
  border: 1px solid #1F1F1F;
  border-radius: 32px;
  background-color: #0088FF;
  color: #fff;
  cursor: pointer;
  font-size: 13px;
  font-family: 'Onest', sans-serif;
  transition: background-color 0.2s, transform 0.2s;

  &:hover {
    background-color: #006fd1; /* чуть темнее при наведении */
  }


`;

export function formatSeconds(secondsRemaining: number): string {
  const minutes = Math.floor(secondsRemaining / 60);
  const seconds = secondsRemaining % 60;
  const minutesStr = String(minutes).padStart(2, "0");
  const secondsStr = String(seconds).padStart(2, "0");
  return `${minutesStr}:${secondsStr}`;
}

const EditIcon = styled(FiEdit)`
  cursor: pointer;
  transition: 0.1s;

  &:hover {
    opacity: 0.75;
    transition: 0.1s;
  }
`;


export const InviterBox: React.FC<{
  title: string;
  completed?: number;
  need?: number;
  secondsRemaining?: number;
  status?: string;
  statusColor?: string;
  onSelect?: () => void;
}> = ({ title, completed = 0, need = 5000, secondsRemaining = 30, status, statusColor, onSelect }) => {
  const [seconds, setSeconds] = useState(secondsRemaining);
  const progress = (completed / need) * 100;
  const progressText = `${completed} из ${need}`;

  useEffect(() => {
    if (status === "waiting" && seconds > 0) {
      const timer = setInterval(() => {
        setSeconds((prev) => Math.max(prev - 1, 0));
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [status, seconds]);

  return (
    <Wrapper>
      <Box>
<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  <Title>Инвайтер {title}</Title>
  <EditIcon size={16} color="#35373B" onClick={onSelect} />
</div>
        {status === "running" && (
          <BarWrapper>
            <ProgressBarFill percent={progress} />
            <ProgressText>{progressText}</ProgressText>
          </BarWrapper>
        )}

        {status === "waiting" && (
          <Status statusColor={statusColor}>
            <div>Ожидаем отлёжку</div>
            <div>{formatSeconds(seconds)}</div>
          </Status>
        )}
        {status === "not_running" && (
        <ExpandButton onClick={onSelect}>
            Развернуть
        </ExpandButton>
        )}
      </Box>
    </Wrapper>
  );
};